import { useEffect, useState } from 'react';
import { ClientFormProgressBar } from './header';
import { useSearchParams } from 'react-router-dom';
import './style.css';
import { DatePicker } from './datepicker';
import { TimePicker } from './timepicker';
import { GuestsPicker } from './guestspicker';
import { GuestInputs } from './guestinputs';
import { createUserReservation, getDaysSlots, getGuestsSlots, getNewTimeSlots, getRestaurantInfo } from '../api/clientform';
import { calendarDays } from '../api/clientform';
import { LoadingAnimation } from '../loading-animation';
import moment from 'moment';
import { getMomentTimeFromUTC, getMomentTimeToUTC } from '../time-manipulations';

declare global {
  interface Window {
    ym: (
      counterId: number,
      event: string,
      goalName: string,
      params?: Record<string, any>
    ) => void;
  }
}

export const NewClientForm: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const restaurantId = Number(searchParams.get('restaurantid') || searchParams.get('restaurantId'));
    const [restaurantName, setRestaurantName] = useState<string>();
    const [restaurantPhone, setRestaurantPhone] = useState<string>();
    const [formColor, setFormColor] = useState<string>('#60A300');
    const [timeZone, setTimeZone] = useState<number>(3);
    const [isAutoSelectTable, setIsAutoSelectTable] = useState(false);
    const [guestName, setGuestName] = useState('');
    const [guestPhone, setGuestPhone] = useState('');
    const [guestNote, setGuestNote] = useState('');
    const [date, setDate] = useState<string>(moment().format('YYYY-MM-DD'));
    const [data, setData] = useState<calendarDays[]>();
    const [internalDate, setInternalDate] = useState(moment().format('YYYY-MM-DD'));
    const [dateSlots, setDateSlots] = useState<number[][]>();
    const [time, setTime] = useState<string>('');
    const [timeSlots, setTimeSlots] = useState<string[]>();
    const [guests, setGuests] = useState<number>(0);
    const [guestsSlots, setGuestsSlots] = useState<number[]>();
    const [dataProcessingAllowed, setDataProcessingAllowed] = useState(false);
    const [stage, setStage] = useState(0);
    const [isFirstStageDone, setIsFirstStageDone] = useState(false);
    const [isSecondStageDone, setIsSecondStageDone] = useState(false);
    const [isThirdStageDone, setIsThirdStageDone] = useState(false);
    const [isFourthStageDone, setIsFourthStageDone] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [serverError, setServerError] = useState('');

    const [touchstartX, setTouchStartX] = useState(0);
    const [touchendX, setTouchendX] = useState(0);

    const [yaMetric, setYaMetric] = useState<number>(0);

    const createReserve = () => {
        if (isFirstStageDone && isSecondStageDone && isThirdStageDone && dataProcessingAllowed) {
            setIsLoading(true);
            createUserReservation(restaurantId, guestName, guestPhone, guests, date, time, guestNote, dataProcessingAllowed).then((data) => {
                window.ym(yaMetric, 'reachGoal', 'booking_complete');
                document.location.href = '/showreserve?reserveId=' + data.payload;
            })
                .catch((data) => {
                    try {
                        if (data.errors)
                        setServerError(data.errors[0].error_text);
                    else
                        setServerError('Ошибка сервера, попробуйте перезагрузить страницу');
                    }
                    catch {
                        setServerError('Ошибка сервера, попробуйте перезагрузить страницу');
                    }
                    
                }).finally(() => {
                    setIsLoading(false);
                });
        }
    }

    useEffect(() => {
        if (touchendX > touchstartX + 50) {
            if (stage > 0) setStage(stage - 1);
        }
        if (touchendX < touchstartX - 50) {
            if (stage == 0 && isFirstStageDone) setStage(1);
            if (stage == 1 && isSecondStageDone) setStage(2);
            if (stage == 2 && isThirdStageDone) setStage(3);
        }
    }, [touchendX])

    const touchEndHandler = (e: any) => {
        setTouchendX(e.changedTouches[0].screenX);
    }

    const touchStartHandler = (e: any) => {
        setTouchStartX(e.changedTouches[0].screenX);
    }

    const handleSetDate = (externalDate: string) => {
        setTimeout(() => { setStage(1); }, 300);
            setIsLoading(true);
            if (externalDate != date || !isFirstStageDone) {
                setDate(externalDate);
                getNewTimeSlots(externalDate, restaurantId).then(result => {
                    // result = result.map(r => {
                    //     return getMomentTimeFromUTC(r.length > 8 ? r.slice (2,7) : r, 'HH:mm:ss').format('HH:mm:ss');
                    // })
                    setTimeSlots(result);
                    setIsLoading(false);
                    setIsSecondStageDone(false);
                    setTime('');
                    setIsThirdStageDone(false);
                });
            } else {
                setIsLoading(false);
            }
            setIsFirstStageDone(true);
    }

    const handleSetTime = (externalTime: string) => {
        setTimeout(() => { setStage(2); }, 300);
        setIsLoading(true);
        if (externalTime != time || !isSecondStageDone) {
            setTime(externalTime);
            getGuestsSlots(date, date + 'T' + getMomentTimeToUTC(externalTime, 'HH:mm').format('HH:mm'), restaurantId).then(result => {
                setGuestsSlots(result);
                setIsLoading(false);
                setGuests(0);
                setIsThirdStageDone(false);
            })
        } else {
            setIsLoading(false);
        }
        setIsSecondStageDone(true);
    }

    const handleSetGuests = (externalGuests: number) => {
        setTimeout(() => { setStage(3); }, 300);
        
            setGuests(externalGuests);

        setIsThirdStageDone(true);
    }

    useEffect(() => {
        getRestaurantInfo(restaurantId).then((data) => {
            localStorage.setItem('timezone', data.timeZone.toString());
            setRestaurantName(data.name);
            setRestaurantPhone(data.phone);
            setFormColor(data.color);
            setTimeZone(data.timeZone);
            setIsAutoSelectTable(data.isAutoSelectTable);
            setYaMetric(data.yandexMetricCounter)
            const script = document.createElement('script');
    script.innerHTML = `
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${data.yandexMetricCounter}', 'ym');

    ym(${data.yandexMetricCounter}, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", accurateTrackBounce:true, trackLinks:true});
    `;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${data.yandexMetricCounter}" style="position:absolute; left:-9999px;" alt="" /></div>`;
    document.body.appendChild(noscript);
        });
        document.addEventListener('touchstart', touchStartHandler)
        document.addEventListener('touchend', touchEndHandler);
        return () => {
            document.removeEventListener('touchstart', touchStartHandler)
            document.removeEventListener('touchend', touchEndHandler);
        }
    }, []);

    useEffect(() => {
        setIsLoading(true);
        if (restaurantName) {
            getDaysSlots(internalDate.slice(5, 7), internalDate.slice(0, 4), restaurantId).then(result => {
                setIsLoading(false);
                setData(result);
                const arr: number[][] = [[], [], [], [], [], []];
                result.forEach((e, index) => {
                    arr[Math.floor(index / 7)].push(e.day);
                })
                setDateSlots(arr);
            })
        }

    }, [internalDate, restaurantName]);

    // useEffect(() => {

    //     if (isSecondStageDone) {
    //         setTimeout(() => { setStage(2); }, 300);
    //         setIsLoading(true);
    //         getGuestsSlots(date + 'T' + time, 1).then(result => {
    //             setGuestsSlots(result);
    //             setIsLoading(false);
    //             setGuests(0);
    //             setIsThirdStageDone(false);
    //         })
    //     }
    // }, [time, isSecondStageDone])

    // useEffect(() => {

    //     if (isThirdStageDone) {
    //         setTimeout(() => { setStage(3); }, 300);
    //     }
    // }, [guests, isThirdStageDone])

    return (
        <>
            <LoadingAnimation isLoading={isLoading}></LoadingAnimation>
            {restaurantName && (
                <div className="interactive-form">
                    <div className="interactive-form__flex">
                        <div style={{color: formColor}} className="interactive-form__header">{restaurantName}</div>
                        <ClientFormProgressBar formColor={formColor} stage={stage} setStage={setStage} date={date} time={time} guests={guests} isFirstStageDone={isFirstStageDone} isSecondStageDone={isSecondStageDone} isThirdStageDone={isThirdStageDone} isFourthStageDone={isFourthStageDone} />
                        <div className='interactive-form__slider'>
                            <div className='interactive-form__content'>
                                <DatePicker formColor={formColor} stage={stage} data={data} internalDate={internalDate} setInternalDate={setInternalDate} date={date} handleSetDate={handleSetDate} dateSlots={dateSlots} isStageDone={isFirstStageDone} />
                                <TimePicker formColor={formColor} timeSlots={timeSlots} time={time} setTime={handleSetTime} restaurantPhone={restaurantPhone} />
                                <GuestsPicker isAutoSelectTable={isAutoSelectTable} formColor={formColor} guestsSlots={guestsSlots} guests={guests} setGuests={handleSetGuests} restaurantPhone={restaurantPhone} />
                                <GuestInputs 
                                formColor={formColor} 
                                guestName={guestName} 
                                setGuestName={setGuestName} 
                                guestPhone={guestPhone} 
                                setGuestPhone={setGuestPhone} 
                                guestNote={guestNote} 
                                setGuestNote={setGuestNote} 
                                isStageDone={isFourthStageDone} 
                                setIsStageDone={setIsFourthStageDone} 
                                createReserve={createReserve} 
                                serverError={serverError}
                                dataProcessingAllowed={dataProcessingAllowed}
                                setDataProcessingAllowed={setDataProcessingAllowed}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='interactive-form__footer'>
                        {/* <a href='https://digital-horeca.ru/' target="_blank" className='interactive-form__label'>Бамбук - система бронирования столиков</a> */}
                        <a target='_blank' href='https://bambook.place/' className='interactive-form__label'>Бамбук - надёжная система бронирования столов</a>
                    </div>
                    
                </div>
            )}


        </>);
}
